import React, { useState, useEffect } from 'react'

import {
    // Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Box,
    styled,
    Card,
    Tabs,
    Tab,
    Grid,
    Typography,
    Paper,
    Divider,
    ImageList,
    ImageListItem
} from '@mui/material';

import {
    // Search as SearchIcon,
    Close as CloseIcon,
    // FindInPageOutlined as FindInPageOutlinedIcon,
} from '@mui/icons-material'

import CommonSectionHeader from '../../components/common/CommonSectionHeader'

import { useSystemUtils } from '../useSystemUtils';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(0)
}));

const StyledCardContent = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: 0
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

const StyledRowLabel = styled(Typography)(({ theme }) => ({
    fontWeight: 800,
    fontSize: '0.9rem'
}))

const StyledRowContent = styled(Typography)(({ theme }) => ({
    // fontWeight: 800
    fontSize: '0.9rem'
}))

export default function useUomView(
    {
        // id,
        // dialogData,
        // dialogOpen,
        id,
        handleOnCancel,
        // handleOnSelect,
        // textProps
    }
) {

    const [viewId, setViewId] = useState()
    const [open, setOpen] = useState()
    const [data, setData] = useState()

    const [tabValue, setTabValue] = React.useState(0);

    const { currencyAbb } = useSystemUtils();

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleExit = () => {
        setOpen(false);

        if (handleOnCancel)
            handleOnCancel();
    }

    const openView = ({ id, data, open }) => {
        setViewId(id)
        setOpen(open);
        setData(data);
    }

    const closeView = () => {
        setOpen(false);
        setData(null)
    }

    const RenderInfoTab = () => {
        return (
            <Grid container sx={{ p: 3, pt: 1 }} spacing={2}>
                <Grid item md={6}>
                    <StyledCard>
                        <StyledCardContent>
                            <CommonSectionHeader
                                title='Details'
                            />
                        </StyledCardContent>
                        <StyledDivider />
                        <StyledCardContent>
                            <Grid container rowGap={2}>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Product Name</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.item_name}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Product Code</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.product_code}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>UOM</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.uom_name}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Code</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.code}</StyledRowContent>
                                </Grid>
                                {/* <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Display Code</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.code}</StyledRowContent>
                                </Grid> */}

                                {/* <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Supplier</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.supplier_name}</StyledRowContent>
                                </Grid> */}

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Description</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.item_description}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Remark</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.item_remark}</StyledRowContent>
                                </Grid>
                            </Grid>
                        </StyledCardContent>
                    </StyledCard>
                </Grid>
                <Grid item md={6}>
                    <StyledCard>
                        <StyledCardContent>
                            <CommonSectionHeader
                                title='Measurement &amp; Pricing'
                            // subTitle='xxx'
                            />
                        </StyledCardContent>
                        <StyledDivider />
                        <StyledCardContent>
                            <Grid container rowGap={2}>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Cost</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.cost}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>UOM Price</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.uom_price}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Floor Price</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.floor_price}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Volumn Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.volume_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Gross Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.gross_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Net Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.net_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Dimension</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.dimension_width} x {data?.dimension_height} x {data?.dimension_length}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Volumetric</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.cbm}</StyledRowContent>
                                </Grid>


                            </Grid>
                        </StyledCardContent>
                    </StyledCard>
                </Grid>
            </Grid>
        )
    }

    const RenderImagesTab = () => {

        if (!data?.files) return <></>

        const { files } = data;

        return (
            <StyledCard
                sx={{
                    ml: 4,
                    mr: 4
                }}
            >
                <StyledCardContent>
                    <ImageList
                        sx={{
                            // width: 500, 
                            // height: 450 
                        }}
                        variant="quilted"
                        cols={3}
                    // rowHeight={121}
                    >
                        {
                            files.map((item, index) => (
                                <ImageListItem key={index}>
                                    <img
                                        src={`${item.file_url}`}
                                        srcSet={`${item.file_url}`}
                                        alt={item?.description}
                                        loading="lazy"
                                    />
                                </ImageListItem>
                            ))
                        }
                    </ImageList>
                </StyledCardContent>
            </StyledCard>
        )
    }

    const RenderSettingsTab = () => {
        return (
            <Grid container sx={{ p: 3, pt: 1 }} spacing={2}>
                <Grid item md={6}>
                    <StyledCard>
                        <StyledCardContent>
                            <CommonSectionHeader
                                title='Warehouse Scanning'
                            // subTitle='xxx'
                            />
                        </StyledCardContent>
                        <StyledDivider />
                        <StyledCardContent>
                            <Grid container rowGap={2}>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Scan Data Prefix</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.scanning_code_prefix}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Scan Data Suffix</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.scanning_code_suffix}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Show CBM</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.scanning_show_cbm}</StyledRowContent>
                                </Grid>
                            </Grid>
                        </StyledCardContent>
                    </StyledCard>
                </Grid>
                <Grid item md={6}>
                    <></>
                    {/* <StyledCard>
                        <StyledCardContent>
                            <CommonSectionHeader
                                title='Measurement &amp; Pricing'
                                // subTitle='xxx'
                            />
                        </StyledCardContent>
                        <StyledDivider />
                        <StyledCardContent>
                            <Grid container rowGap={2}>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Cost</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.cost}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>UOM Price</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.uom_price}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Floor Price</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{currencyAbb} {data?.floor_price}</StyledRowContent>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Volumn Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.volume_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Gross Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.gross_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Net Weight</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.net_weight}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Dimension</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.dimension_width} x {data?.dimension_height} x {data?.dimension_length}</StyledRowContent>
                                </Grid>

                                <Grid item md={4} xs={12}>
                                    <StyledRowLabel>Volumetric</StyledRowLabel>
                                </Grid>
                                <Grid item md={8} xs={12}>
                                    <StyledRowContent>{data?.cbm}</StyledRowContent>
                                </Grid>


                            </Grid>
                        </StyledCardContent>
                    </StyledCard> */}
                </Grid>
            </Grid>
        )
    }

    const RenderContent = () => {


        let imagesNo = 0;
        let disabledImages = true;

        if (data?.files) {
            if (data.files.length) {
                imagesNo = data.files.length
                disabledImages = false
            }
        }

        return (
            <>
                <Tabs
                    value={tabValue}
                    onChange={(event, newValue) => setTabValue(newValue)}
                    // centered
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    sx={{
                        // backgroundColor: 'red',
                        // mt: 0
                        p: 1
                    }}
                >
                    <Tab label="Information" id={`info`} />
                    <Tab label={`Images (${imagesNo})`} id={`image`} disabled={disabledImages} />
                    <Tab label="Settings" id={`settings`} />
                </Tabs>

                <Box>
                    {
                        tabValue === "" || tabValue === 0 &&
                        RenderInfoTab()
                    }
                    {
                        tabValue === 1 &&
                        RenderImagesTab()
                    }
                    {
                        tabValue === 2 &&
                        RenderSettingsTab()
                    }
                </Box>
            </>
        )
    }

    const UomView = () => {

        if (!viewId) return <></>

        // console.log('data', data);

        return (
            <Dialog
                sx={{
                    '& .MuiDialog-paper':
                    {
                        // width: '80%', 
                        minHeight: '90vh'
                    }
                }}
                fullWidth
                maxWidth="md"
                // TransitionProps={{ onEntering: handleEntering }}
                open={open}
                // {...other}
                onClose={handleExit}
            >
                <DialogTitle
                >
                    Uom Information

                    {/* {JSON.stringify(data)} */}

                    <IconButton
                        aria-label="close"
                        onClick={handleExit}
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>
                <DialogContent
                    dividers
                    // minHeight="100%"
                    sx={{
                        // backgroundColor: 'red',
                        pl: 0,
                        pr: 0,
                        pt: 0
                    }}
                >

                    {
                        RenderContent()
                    }

                </DialogContent>
                {/* <DialogActions>
                    <Button 
                        autoFocus 
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button 
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
            </Dialog>
        )
    }

    return { UomView, openView, closeView }
}
